import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const updateWorkerShiftWorktime = createAsyncThunk(
    "workerShift/update-workerShiftWorktime",
    async ({ token, worktimeData }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/workerWorktime`,
                worktimeData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "Update failed"
            );
        }
    }
);

export const getWorkerShiftWorktime = createAsyncThunk("workerShift/get-workerShiftWorktime", async (token, thunkAPI) => {
    try {
        const res = await axios.get(
            `${BACKEND_URL}/workerWorktimeList`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log("data", res.data);
        return res.data.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch worker worktime");
    }
});


const workerShiftWorktimeSlice = createSlice({
    name: "workerShiftWorktime",
    initialState: {
        workerShiftWorktime: null,
        loading: false,
        error: null,
        message: "",

    },
    extraReducers: (builder) => {
        builder
            .addCase(updateWorkerShiftWorktime.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateWorkerShiftWorktime.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload.message || "Worktime updated successfully!";
            })
            .addCase(updateWorkerShiftWorktime.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Update failed";
            })
            .addCase(getWorkerShiftWorktime.pending, (state) => {
                state.loading = true;
            })
            .addCase(getWorkerShiftWorktime.fulfilled, (state, action) => {
                state.workerShiftWorktime = action.payload.worker_worktime;
                state.loading = false;
            })
            .addCase(getWorkerShiftWorktime.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch worker worktime";
                state.loading = false;
            })
    },
});

export default workerShiftWorktimeSlice.reducer;